import { Route, Routes, useNavigate} from "react-router-dom";
import { useCookies } from "react-cookie";
import { useEffect } from "react";
import Layout from "./Components/Menu/Layout";
import * as common from "./Common/common";
import "./App.css";

import Login from './Pages/Login';
import Dashboard from "./Pages/Dashboard";

//#region Employee/Profile/Settings/Holiday
import Employee from "./Pages/Users/Employee";
import InsertEmployee from './Components/Users/Employee/InsertEmployee';
import EmployeeUpdate from "./Components/Users/Employee/EmployeeUpdate";
import Profile from "./Pages/Users/Profile";
import Role from "./Pages/Users/Role";
import InsertRole from "./Components/Users/Role/InsertRole";
import RoleUpdate from "./Components/Users/Role/RoleUpdate";
import Entitlements from './Pages/MasterSetup/Entitlements';
import Holiday from './Pages/Holiday';
import AllowanceRate from './Pages/MasterSetup/AllowanceRate';
import Permission from './Pages/Users/Permissions';
import Policy from "./Pages/MasterSetup/Policy";
import Leave from "./Pages/Apply/Leave";
import LeaveHistory from "./Pages/History/LeaveHistory";
import Allowance from "./Pages/Apply/Allowance";
import AllowanceHistory from "./Pages/History/AllowanceHistory";
import AllowanceDraft from "./Components/History/Allowance/AllowanceDraft";
import Expenses from "./Pages/Apply/Expenses";
import ExpensesHistory from "./Pages/History/ExpensesHistory";
import ExpensesDraft from "./Components/History/Expenses/ExpensesDraft";
//#endregion

function App() {
  const [cookies, removeCookies] = useCookies([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location === (common.c_getWebUrl() + "Login")) {
      removeCookies();
    }
    // if (!cookies.USER_ID) {
    //   navigate("/Login");
    // }
  }, [cookies.USER_ID, navigate]);

  return (
    <div style={{ fontFamily: "Calibri,  sans-serif" }}>
      {!cookies.USER_ID ? (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Login" element={<Login />} />
          </Routes>
        ) : (
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/Login" element={<Login />} />
              <Route element={<Layout />}>
                <Route path="/Dashboard" element={<Dashboard />} />
                <Route path="/Leave" element={<Leave />} />
                <Route path="/LeaveHistory" element={<LeaveHistory />} />
                <Route path="/Allowance" element={<Allowance/>} />
                <Route path="/AllowanceHistory" element={<AllowanceHistory/>} />
                <Route path="/AllowanceDraft" element={<AllowanceDraft/>} />
                <Route path="/Expenses" element={<Expenses/>} />
                <Route path="/ExpensesHistory" element={<ExpensesHistory/>} />
                <Route path="/ExpensesDraft" element={<ExpensesDraft/>} />
                <Route path="/employee" element={<Employee />} />
                <Route path="/insertemployee" element={<InsertEmployee />} />
                <Route path="/employeeupdate" element={<EmployeeUpdate />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/role" element={<Role />} />
                <Route path="/insertrole" element={<InsertRole />} />
                <Route path="/roleupdate" element={<RoleUpdate/>} />
                <Route path="/permission" element={<Permission />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/entitlements" element={<Entitlements />} />
                <Route path="/holiday" element={<Holiday />} />
                <Route path="/allowancerate" element={<AllowanceRate />} />
              </Route>
            </Routes>
        )}
    </div>
  );
}

export default App;
